import React,  { useState, useEffect} from 'react';
import { Card, Table, Row, Col, Button, Container } from 'react-bootstrap';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import useFetchCase from '../hooks/useFetchCase';
import config from '../config';
import axios from 'axios';

function OpenEnrollment({ caseId, onError = () => { }}) {

    const fetchUrl = `${config.API_URL}/CobraOpenEnrollmentManagements/ByCaseId/${caseId}`;

    const [cobraOpenEnrollmentManagement, setEnrollmentMethod] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    

    useEffect(() => {
        fetchEnrollmentMethod();
    }, [caseId]);

    const fetchEnrollmentMethod = async () => {
        try {
            const response = await axios.get(fetchUrl);
            setEnrollmentMethod(response.data || null);
        } catch (error) {
            setError('Error fetching plans.');
            onError(error);
        } finally {
            setLoading(false);
        }
    };


    if (loading) return <Skeleton count={10} />;
    if (error) return <div>{error}</div>;


  return (
    <Col lg={12} className="mb-3">
                            <Card>
                                <Card.Body>
                                
                                    <Row>
                                        <Col lg={6}>
                                            <Card.Title>COBRA Open Enrollment Management</Card.Title>
                                        </Col>
                                        <Col lg={6} className="text-end">
                                            {/* Edit and delete buttons */}
                                            {/* <Button
                                                variant="link"
                                                href="#"
                                                className="cobra-summary-edit"
                                                onClick={() => console.log('Edit clicked')}
                                            >
                                                <FaEdit />
                                            </Button> */}
                                            
                                        </Col>
                                    </Row>
                                    <Col lg={12}>
                                    <div className="table-responsive">
                                    <table className="styled-table table-hover mb-0">
                                            
                                            <tbody>
                                            
                                                <tr>
                                                    <th className="">
                                                    Open Enrollment Method
                                                    </th>
                                                    
                                                    
                                                    <td>{cobraOpenEnrollmentManagement.openEnrollmentMethod === "ParticipantEnrollOnline" ? "Participant will enroll online with Clarity" :
                                        cobraOpenEnrollmentManagement.openEnrollmentMethod === "Broker/Client will manage Open Enrollment" ? "Broker/Client will manage Open Enrollment" :
                                        cobraOpenEnrollmentManagement.openEnrollmentMethod === "No Open Enrollment" ? "No Open Enrollment" : ""}</td>
                                                        
                                                </tr>
                                                {cobraOpenEnrollmentManagement.openEnrollmentMethod === 'ParticipantEnrollOnline' && (
                                                    <>
                                                    <tr>
                                                        <th className="">
                                                        How many days are you offering open enrollment to active employees?
                                                        </th>
                                                        
                                                        <td className="cobra">
                                                            {cobraOpenEnrollmentManagement.noOfDaysOffered}
                                                        </td>
                                                    </tr>


                                                </>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>
                                    </Col>
                                </Card.Body>
                            </Card>
                        </Col>
  )
}

export default OpenEnrollment
